module.exports = __webpack_public_path__ + "img/img_T6.5.c5530bdd.png";